import { Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';

// Types of contract in the contract history, grouped as in the picker. Mirrors
// server-hlb/components/contracts/v1/employmentContractTypes.js; the first six
// keys are the employee profile's employment types.
const CONTRACT_TYPE_GROUPS = [
  { key: 'employment', types: ['limited', 'unlimited', 'director'] },
  {
    key: 'outside',
    types: [
      'ppPoslovi',
      'ugovorODelu',
      'autorskiUgovor',
      'dopunskiRad',
      'traineeship',
      'volunteering',
      'internship',
    ],
  },
  { key: 'other', types: ['other'] },
];

const EMPLOYMENT_TYPES = CONTRACT_TYPE_GROUPS[0].types;
const ALL_TYPES = CONTRACT_TYPE_GROUPS.flatMap((group) => group.types);

export const isContractType = (type) => ALL_TYPES.includes(type);

/**
 * Entries numbered together: all employment contracts form one sequence,
 * every other type its own.
 */
export const contractSequenceKey = (entry) =>
  EMPLOYMENT_TYPES.includes(entry?.employmentType)
    ? 'employment'
    : entry?.employmentType || 'employment';

export const contractTypeLabel = (t, entry) =>
  entry?.employmentType === 'other'
    ? entry?.otherTypeName || t('forms:contractTypes.other')
    : t(`forms:contractTypes.${entry?.employmentType || 'limited'}`);

export const contractTypeColor = (type) => {
  if (type === 'unlimited') return 'green';
  if (type === 'limited') return 'blue';
  if (type === 'director') return 'gold';
  return 'cyan';
};

/**
 * Type picker of a contract, plus the name field for "Other". `namePrefix`
 * places both under a nested form path (e.g. ['contract']).
 */
export function ContractTypeFields({ namePrefix = [], type }) {
  const { t } = useTranslation('forms');
  const options = CONTRACT_TYPE_GROUPS.map((group) => ({
    label: t(`forms:contractTypeGroup.${group.key}`),
    options: group.types.map((key) => ({
      value: key,
      label: t(`forms:contractTypes.${key}`),
    })),
  }));

  return (
    <>
      <Form.Item
        name={[...namePrefix, 'employmentType']}
        label={t('forms:contractEmploymentType', 'Vrsta ugovora')}
      >
        <Select options={options} showSearch optionFilterProp="label" />
      </Form.Item>
      {type === 'other' && (
        <Form.Item
          name={[...namePrefix, 'otherTypeName']}
          label={t('forms:contractOtherTypeName', 'Naziv ugovora')}
          rules={[{ required: true, whitespace: true }]}
        >
          <Input />
        </Form.Item>
      )}
    </>
  );
}
